import type { Locale } from "@/i18n/locales";

import { chrome as en } from "./en/chrome";
import { chrome as de } from "./de/chrome";
import type { ChromeContent } from "./types";

/**
 * Typing the registry as `Record<Locale, ChromeContent>` is what forces a new
 * locale to arrive COMPLETE: adding `"fr"` to `LOCALES` fails to compile until a
 * French module exists carrying every field. Completeness is a compile error,
 * not a parity test — which is strictly stronger, because a parity test that
 * compares locales to each other is green when a field is missing from all of
 * them.
 */
export const CHROME: Readonly<Record<Locale, ChromeContent>> = { en, de };

export function chromeFor(locale: Locale): ChromeContent {
  return CHROME[locale];
}
